function wrapMDCodeTabs(str) {
    const regex = /<p>\+\+code-tabs<\/p>([\s\S]+?)<p>\+\+end-code-tabs<\/p>/g;

    let m;
    let finalHTML = str;
    let codeTabsIndex = 1;

    while ((m = regex.exec(str)) !== null) {
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        if (m[1]) {
            const tabs = generateTabs(codeTabsIndex, m[1]);
            finalHTML = finalHTML.replace(m[0], tabs);
            codeTabsIndex++;
        }
    }

    return finalHTML;
}

function generateTabs(codeTabsIndex, str) {
    const regex = /<p>\+\+tab-(.+?)<\/p>([\s\S]+?)<p>\+\+end-tab<\/p>/g;

    let m;
    let tabsHTML = "";
    let index = 1;

    while ((m = regex.exec(str)) !== null) {
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        if (m[1] && m[2]) {
            tabsHTML += generateTab(codeTabsIndex, index, m[1], m[2]);
            index++;
        }
    }

    return `<div class="code-tabs">${tabsHTML}</div>`;
}

function generateTab(codeTabsIndex, index, name, content) {
    const checked = index === 1 ? "checked" : "";
    return `
            <input type="radio"
                name="code-tabs-${codeTabsIndex}"
                id="tab-${codeTabsIndex}-${index}"
                ${checked}
                class="tab-switch">
            <label for="tab-${codeTabsIndex}-${index}" class="tab-label" data-lng="${name}">${name}</label>
            <div class="tab-content">${content}</div>
        `;
}

export default wrapMDCodeTabs;



// WEBPACK FOOTER //
// ./src/utils/wrapMDCodeTabs.js